import React from 'react';

import Edit from './Contents/Edit'
import View from './Contents/View'

const Contents = (props) => {
    const originalReportStatusID = props.originalReportStatusID

    if ( originalReportStatusID === 1 ) {
        return <Edit {...props} />
    }
    else if ( originalReportStatusID === 2 ) {
        return <View {...props} />
    }
    else {
        alert('Orig report status is unknown: ' + originalReportStatusID)
    }
}

export default Contents
